import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { NavBarAdmin } from '../../NavBar/NavBarAdmin'
import { Dashboard } from '../dashboard/Dashboard'

export const AdminSchoolRoutes = () => {
  return (
    <div>
      <NavBarAdmin />
      <Routes>
        <Route path="home" element={<Dashboard />} />
      </Routes>
    </div>
  )
}
